export const StatusBusinessPlanEnum = {
  "PREENCHIMENTO": 1,
  "APROVACAO": 2,
  "ANDAMENTO": 3,
  "PRE_AMORTIZACAO": 4,
  "AMORTIZACAO": 5,
  "REPROVADO": 6,
  "PREENCHIMENTO_NOVA_VERSAO": 7,
  "APROVACAO_NOVA_VERSAO": 8
};

export const StatusBusinessPlanLabels = {
  [StatusBusinessPlanEnum.PREENCHIMENTO]: "Em preenchimento",
  [StatusBusinessPlanEnum.APROVACAO]: "Aprovação",
  [StatusBusinessPlanEnum.ANDAMENTO]: "Em andamento",
  [StatusBusinessPlanEnum.PRE_AMORTIZACAO]: "Pré-amortização",
  [StatusBusinessPlanEnum.AMORTIZACAO]: "Amortização",
  [StatusBusinessPlanEnum.REPROVADO]: "Reprovado",
  [StatusBusinessPlanEnum.PREENCHIMENTO_NOVA_VERSAO]: "Em preenchimento de nova versão",
  [StatusBusinessPlanEnum.APROVACAO_NOVA_VERSAO]: "Aprovação de nova versão",
  "PREENCHIMENTO": "Em preenchimento",
  "APROVACAO": "Aprovação",
  "ANDAMENTO": "Em andamento",
  "PRE_AMORTIZACAO": "Pré-amortização",
  "AMORTIZACAO": "Amortização",
  "REPROVADO": "Reprovado",
  "PREENCHIMENTO_NOVA_VERSAO": "Em preenchimento de nova versão",
  "APROVACAO_NOVA_VERSAO": "Aprovação de nova versão"
};

export const StatusWorkflowEnum = {
  "REPROVADO": -1,
  "AJUSTE": 1,
  "APROVADO": 8,
};

export const TipoVPLEnum = {
  "RETORNO": 1,
  "CUSTO": 2,
};
